import { useCallback } from 'react';

import { BRAND_VOICE_ASSET_FIELD } from 'src/data/brandVoice';
import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { useErrorHandler, useRefreshBrandVoiceToneOfVoices } from 'src/services';
import { useBrandVoicesActions, useCustomModelsActions, useNotificationActions } from 'src/store';

import { CustomModelSuccessPopup } from './CustomModelSuccessPopup';

export const CUSTOM_MODEL_SUCCESS_POPUP = Symbol('CUSTOM_MODEL_SUCCESS');

export const useCustomModelSuccessPopup = () => {
  const popups = usePopups();
  const notifications = useNotificationActions();
  const brandVoicesActions = useBrandVoicesActions();
  const customModelsActions = useCustomModelsActions();
  const handleError = useErrorHandler();
  const refreshBrandVoiceToneOfVoices = useRefreshBrandVoiceToneOfVoices();

  useEffectOnce(() => {
    popups.registerPopup(CUSTOM_MODEL_SUCCESS_POPUP, CustomModelSuccessPopup);
  });

  return useCallback(
    ({ customModel }) => {
      return popups.openPopup(CUSTOM_MODEL_SUCCESS_POPUP, {
        onClose: async (shouldSetAsDefault) => {
          if (shouldSetAsDefault) {
            try {
              await customModelsActions.updateDefaultCustomModel(customModel, true);
              brandVoicesActions.storeBrandVoiceItemInCache({
                itemsField: BRAND_VOICE_ASSET_FIELD.customModels,
                item: customModel,
                brandVoiceId: customModel.brandVoice.id,
              });
              refreshBrandVoiceToneOfVoices(customModel.brandVoice?.id);
              notifications.displaySuccess('Custom model updated');
            } catch (error) {
              handleError(error);
            }
          }
          popups.closePopup(CUSTOM_MODEL_SUCCESS_POPUP);
        },
        customModel,
      });
    },
    [
      popups,
      customModelsActions,
      brandVoicesActions,
      refreshBrandVoiceToneOfVoices,
      notifications,
      handleError,
    ]
  );
};
